"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 3v8h2v2H1a1 1 0 01-1-1V2a1 1 0 011-1h18a1 1 0 011 1v10a1 1 0 01-1 1h-3v-2h2V3H2zm9 11h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H7c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2z"];
//# sourceMappingURL=add-child.js.map